import {Link, LinkProps, SvgIconProps} from "@mui/material";
import {MAIN_PAGE} from "constants/common";
import Logo from "assets/icons/Logo";

interface MainLogoProps {
  linkProps?: LinkProps;
  iconProps?: SvgIconProps
}

const MainLogo = ({linkProps, iconProps}: MainLogoProps) => {
  return (
    <Link href={MAIN_PAGE} target={'_blank'} {...linkProps}>
      <Logo {...iconProps}/>
    </Link>
  )
}

export default MainLogo;
